import { Link } from '@tanstack/react-router';
import { LuChevronLeft } from 'react-icons/lu';

type AdminBackLinkProps = {
  to: string;
  search?: Record<string, unknown>;
};

/** 「戻る」ナビゲーションリンク */
export default function AdminBackLink({ to, search }: AdminBackLinkProps) {
  return (
    <Link
      to={to}
      search={search}
      className="inline-flex items-center gap-1 border-0 bg-transparent p-0 text-base font-bold text-[#777] no-underline shadow-none hover:opacity-80"
    >
      <LuChevronLeft className="size-4" />
      戻る
    </Link>
  );
}
